import React, { FC } from 'react'
import {
  StepConnector as MuiStepConnector,
  StepConnectorProps,
  createStyles,
  makeStyles,
  Theme,
} from 'transfix-ui/core'

const useSidebarStepConnectorStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(1),
      position: 'relative',
      zIndex: 10,
    },
    lineVertical: {
      minHeight: 0,
      borderLeftWidth: 2,
    },
    vertical: {
      padding: `0 0 ${theme.spacing(0.5)}`,
    },
    line: {
      borderColor: '#A9B2BD',
    },
  })
)

export const SidebarStepConnector: FC<StepConnectorProps> = props => {
  const classes = useSidebarStepConnectorStyles()
  return <MuiStepConnector {...props} classes={classes} />
}
